export default [
  {
    path: '/hospital-profiles',
    name: 'hospital-profile',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/student-healt/hospital-profile/index-v2.vue')
  },
  {
    path: '/hospital-profiles/:id',
    name: 'hospital-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-healt/hospital-profile/index.vue'),
    props: route => ({ editData: route.params.editData })
  }
]
